<template>
	<div>
		<div class="my_order_checkstand comBox" style="overflow: hidden;">
			<div style="font-size: 0.2rem;margin-bottom: 0.2rem;margin-top: 0.2rem;">收银台</div>

			<!-- 支付中 -->
			<div v-if="status == 0" style="width: 8.8rem;margin: 0 auto;">
				<div style="width: 0.48rem;height: 0.48rem;margin: 0 auto;">
					<img style="width: 100%;height: 100%;" src="@/assets/img/tips／check-circle-fill@2x.png" />
				</div>
				<div class="payText1">订单提交成功，请尽快完成付款!</div>
				<div class="payText2">订单号：{{ orderDetail.orderNo }} <span style="color:#C01A26 ;">{{ countdown }}</span>
					后订单将自动关闭
				</div>
				<div style="margin-bottom: 0.22rem;text-align: center;">应付金额：<span
						style="font-size: 0.24rem;color:#C01A26 ;">￥{{
				(totalPay / 1).toFixed(2) }}</span></div>
				<div class="CollectionInformation">
					<div class="CollectionInformationItem">
						<span>收货人：</span>
						<div>{{ orderDetail.memberName }}</div>
					</div>
					<div class="CollectionInformationItem"><span>收款方：</span>
						<div>{{ orderDetail.sellerName }}</div>
					</div>
					<div class="CollectionInformationItem"><span>商品信息：</span>
						<div>{{ orderDetail.title }}</div>
					</div>
				</div>
				<div style="font-size: 0.14rem;margin-bottom: 0.12rem;">
					选择支付方式
				</div>
				<div style="display: flex;">
					<div class="payItem" :class="payType == 'wx' ? 'payItemSelect' : ''" @click="paySelect('wx')">
						<div style="width: 0.24rem;height: 0.24rem;margin-right: 0.04rem;">
							<img style="width: 100%;height: 100%;" src="@/assets/img/weixin.png" />
						</div>
						<div>微信</div>
						<img v-if="payType == 'wx'" class="paySelectIcon" src="@/assets/img/paySelect.png" />
					</div>
					<div class="payItem" :class="payType == 'zfb' ? 'payItemSelect' : ''" @click="paySelect('zfb')">
						<div style="width: 0.24rem;height: 0.24rem;margin-right: 0.04rem;">
							<img style="width: 100%;height: 100%;" src="@/assets/img/zhifubao.png" />
						</div>
						<div>支付宝</div>
						<img v-if="payType == 'zfb'" class="paySelectIcon" src="@/assets/img/paySelect.png" />
					</div>
				</div>
				<div style="display: flex;justify-content: center;">
					<div class="bnt" @click="paySubmit">立即支付</div>
				</div>

			</div>

			<!-- 支付成功 -->
			<div v-if="status == 1" style="width: 8.8rem;min-height: 4rem;margin: 1rem auto 0;">
				<div style="width: 0.48rem;height: 0.48rem;margin: 0 auto;">
					<img style="width: 100%;height: 100%;" src="@/assets/img/tips／check-circle-fill@2x.png" />
				</div>
				<div class="payText1">订单支付成功</div>
				<div class="payText2">您的订单 {{ orderDetail.orderNo }} 已收录至订单列表可随时查看或下载</div>
				<div class="CollectionInformation" style="display: flex;justify-content: space-between;">
					<div class="CollectionInformationItem" style="display: flex;flex-direction: column;">
						<div>{{ orderDetail.title }}</div>
						<!-- <div style="color: #86909C;margin-top: 0.08rem;">{{ orderDetail.typeNames?.join('-') }}</div> -->
						<div v-if="orderDetail.authType == 'SELF'" style="color: #86909C;margin-top: 0.08rem;">
							个人授权
						</div>
						<div v-if="orderDetail.authType == 'ENTERPRISE'" style="color: #86909C;margin-top: 0.08rem;">
							企业授权
						</div>
						<div v-if="orderDetail.authType == 'UNION'" style="color: #86909C;margin-top: 0.08rem;">
							联盟授权
						</div>

					</div>
					<div class="CollectionInformationItem" style="display: flex;flex-direction: column;justify-content: center;">
						x1
					</div>
					<div class="CollectionInformationItem" style="display: flex;flex-direction: column;justify-content: center;">
						￥{{ (totalPay / 1).toFixed(2) }}
					</div>
				</div>
				<div class="checkstandSuccess">
					<div class="checkstandSuccessItem">
						<span>商品价格：</span>
						<span style="color: #333333;">￥{{ (totalPay / 1).toFixed(2) }}</span>
					</div>
					<div class="checkstandSuccessItem">
						<span>商品数量：</span>
						<span style="color: #333333;">x1</span>
					</div>
					<div class="checkstandSuccessItem">
						<span>合计：</span>
						<span style="color: #FF6000;font-size: 0.2rem;">￥{{ (totalPay / 1).toFixed(2) }}</span>
					</div>
				</div>
				<div style="display: flex;justify-content: center;">
					<div class="bnt" @click="materialDown" style="width: 1.36rem;margin-right: 0.24rem;">下载素材</div>
					<div class="bnt" @click="orderView"
						style="width: 1.36rem;border: 0.01rem solid #86909C;color: #333333;background: transparent;">查看订单</div>
				</div>


			</div>

			<!-- 支付失败 -->
			<div v-if="status == 2" style="width: 8.8rem;min-height: 4rem;margin: 1rem auto 0;">
				<div style="width: 0.48rem;height: 0.48rem;margin: 0 auto;">
					<img style="width: 100%;height: 100%;" src="../../assets/scxx_no.png" />
				</div>

				<div class="payText1">订单已取消</div>
				<div class="payText2">您的订单 {{ orderDetail.orderNo }} 超时未完成支付</div>

				<div style="display: flex;justify-content: center;">
					<div class="bnt" style="width: 1.36rem;" @click="paymentClick">重新购买</div>
				</div>
			</div>


		</div>
		<!-- 支付宝二维码 -->

		<el-dialog title="" @close="dialogZfbClose" v-model="dialogZfbVisible" align-center width="480px" :close-on-click-modal="false">
			<div class="qrcode" :style="'background-image: url(' + qrcode + ');'"></div>
			<div style="text-align: center;font-size: 0.2rem;" v-show="payType == 'zfb'">请用支付宝扫码支付</div>
			<div style="text-align: center;font-size: 0.2rem;" v-show="payType == 'wx'">请用微信扫码支付</div>
		</el-dialog>

	</div>
</template>

<script lang="ts" setup>
import leftTemplate from '@/components/leftTemplate.vue'
import {
	ref,
	computed,
	onMounted
} from 'vue'
import {
	ElMessage,
	ElTable
} from "element-plus";
import {
	Axios
} from "../../assets/js/ls_com_axios.js";

import {
	useRoute,
	useRouter,
} from 'vue-router';
import { log } from 'console';

const router = useRouter();
const route = useRoute();

const totalPay = route.query.totalPay;
const orderIds = route.query.arry;
const orderType = route.query.type;
const authType = route.query.authType;




let status = ref(0); //0 支付中，1 成功  ，2失败
let payType = ref('zfb');

const paySelect = (type) => {

	// if (type == 'wx') {
	// 	ElMessage({
	// 		message: "待开发",
	// 		type: "error",
	// 	});
	// } else {
	// 	payType.value = type;
	// }
	payType.value = type
}


let dialogZfbVisible = ref(false);
let payStatus = ref('');
//15分钟倒计时取消订单
const countdownTime = ref<number>(1800); // 30分钟的秒数
// const countdownTime = ref < number > (2); // 2秒的秒数
const countdown = computed<string>(() => {
	const minutes = Math.floor(countdownTime.value / 60);
	const seconds = countdownTime.value % 60;
	return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
});

const countdownTimefun = ref('')
const startCountdown = () => {
	countdownTimefun.value = setInterval(() => {
		if (countdownTime.value > 0) {
			countdownTime.value--;

		}
		if (countdownTime.value == 0) {
			clearInterval(countdownTimefun.value);
			Axios('post', '/fodder/order/cancel/' + orderDetail.value.id, {}, false, function (res) {
				dialogZfbVisible.value = false;
				status.value = 2;
				ElMessage({
					message: "订单已取消",
					type: "success",
				});
			})
		}
	}, 1000);
};



//支付宝付款状态
const getStatus = (sceneId) => {
	Axios("get", "/pay/pay-status/" + sceneId, false, false, (resp) => {
		if (resp.data.data) {
			dialogZfbVisible.value = false;
			clearInterval(payStatus.value);
			clearInterval(payQrcode.value);
			status.value = 1;
		}
	})
}

//订单详情
let orderDetail = ref({});
const init = () => {
	// .split(',')[0]
	Axios("get", "/fodder/order/info/" + orderIds, false, false, (res) => {

		orderDetail.value = res.data.data[0];
		orderDetail.value.orderNo = res.data.data.map(obj => obj.orderNo).join(",")
		// orderDetail.value.memberName = res.data.data.map(obj => obj.memberName).join(",")
		let tetete = res.data.data.map(obj => { return { "sellerName": obj.sellerName, "sellerId": obj.sellerId } })
		let zhuantete: any = []
		tetete.forEach(el => {
			if (!zhuantete.some(e => e.sellerId == el.sellerId)) {
				zhuantete.push(el);
			}
		});
		console.log('tetete', tetete)
		console.log(zhuantete)
		orderDetail.value.sellerName = zhuantete.map(obj => obj.sellerName).join(",")
		orderDetail.value.title = res.data.data.map(obj => obj.title).join(",")
		orderDetail.value.id = res.data.data.map(obj => obj.id).join(",")
		if (orderDetail.value.status == "1") {
			status.value = 1
		} else if (orderDetail.value.status == "3" || orderDetail.value.status == "2") {
			status.value = 3
		}
		const createTime = new Date(orderDetail.value.createTime).getTime()
		const now = new Date().getTime()
		console.info((now - createTime) / 1000)
		countdownTime.value = 1800 - parseInt((now - createTime) / 1000)
		startCountdown();
	})
}
init();

// 支付宝扫码付款
let payQrcode = ref('');
let qrcode = ref('');
const paySubmit = () => {
	//判断orderType 是购物车支付还是订单支付
	let url:any;
	if(payType.value == 'zfb'){
		url = orderType == 'car' ? '/fodder/car/create-pay/ALIPAY/' : '/fodder/order/create-pay/ALIPAY/'
	}else if(payType.value == 'wx'){
		url = orderType == 'car' ? '/fodder/car/create-pay/WXPAY/' : '/fodder/order/create-pay/WXPAY/'
	}
	createPay(url, 1);
	payQrcode.value = setInterval(() => {
		createPay(url);
	}, 50000)
}
const createPay = (url, num = '') => {
	Axios("post", url + orderIds, false, false, (res) => {
		let data = res.data.data;
		qrcode.value = data.qrcode;
		dialogZfbVisible.value = true;
		if (num == 1) {
			payStatus = setInterval(() => {
				getStatus(data.sceneId);
			}, 2000)
		}

	});
}
//支付宝窗口关闭
const dialogZfbClose = () => {
	dialogZfbVisible.value = false;
	//关闭二维码和支付状态的调用
	clearInterval(payStatus.value);
	clearInterval(payQrcode.value);

}
//重新下订单
const paymentClick = () => {
	console.log(orderDetail)
	Axios("post", "/fodder/order", { materialId: orderDetail.value.materialId, authType: authType }, false, function (res) {
		status.value = 0;
		init();
	});
}
//订单查看
const orderView = () => {
	router.push({
		path: "/myOrder",
	});
}
const materialDown = () => {
	router.push({
		path: "/purchasedMaterial"
	});
}
</script>

<style scoped>
@import url(/src/assets/css/com.css);

.my_order_checkstand {
	margin: 0 auto;
}

.qrcode {
	width: 3rem;
	height: 3rem;
	margin: 0 auto;
	background-position: center;
	background-size: 100% 100%;
	background-repeat: no-repeat;
}


.CollectionInformation {
	padding: 0.2rem 0.24rem 0.08rem;
	background: #F2F3F5;
	box-sizing: border-box;
	margin: 0.4rem 0 0.24rem;
	border-radius: 0.08rem;
}

.CollectionInformationItem {
	display: flex;
	margin-bottom: 0.12rem;
	font-size: 0.14rem;
}

.bnt {
	width: 2.68rem;
	height: 0.45rem;
	background: #C01A26;
	border-radius: 0.08rem;
	opacity: 1;
	margin-top: 0.29rem;
	margin-bottom: 0.29rem;
	text-align: center;
	line-height: 0.45rem;
	color: #fff;
	cursor: pointer;

}

.payItem {
	width: 0.96rem;
	height: 0.4rem;
	line-height: 0.4rem;
	font-size: 0.14rem;
	color: #333;
	border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
	opacity: 1;
	border: 0.01rem solid #E5E6EB;
	margin-left: 0.12rem;
	display: flex;
	justify-content: center;
	position: relative;
}

.payItemSelect {
	border: 0.01rem solid #C01A26;

}

.paySelectIcon {
	width: 0.25rem;
	height: 0.25rem;
	position: absolute;
	bottom: -0.016rem;
	right: -0.016rem;
}

.payText1 {
	margin: 0.16rem 0 0.04rem;
	font-size: 0.14rem;
	text-align: center;
}

.payText2 {
	text-align: center;
	color: #86909C;
	font-size: 0.14rem;
}

.checkstandSuccessItem {
	display: flex;
	justify-content: space-between;
	margin-top: 0.16rem;
	color: #86909C;
}
</style>
